<template>
  <vshare :vshareConfig="vshareConfig"></vshare>
</template>

<script>
export default {
  // 百度分享插件
  data () {
    return {
      vshareConfig: {
        shareList: [],
        common: {
          bdText: '万知',
          bdUrl: 'http://wz.gg',
          bdStyle: '1',
          bdSize: '16'
        },
        share: [{
          bdSize: 16
        }],
        // 禁用右侧悬浮分享
        slide: false,
        image: [],
        selectShare: []
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/Share.vue